<template>
  <div class="footer_auth">
    <v-btn text to="/">INICIO</v-btn>
    <v-btn text to="/price">Precios</v-btn>
    <v-btn text to="/help">ayuda</v-btn>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
@import '../assets/scss/base.scss';
.footer_auth {
  position: absolute;
  bottom: 0;
  width: 100%;
  background: $bg-hero;
  padding: 5px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: row;
}
</style>
